
import { defineComponent, ref } from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
// import FilterList from "@/components/dropdown/FilterList.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import axios from "@/axios-instance"
import moment from "moment"
import { exportStyledXlsx, formatMoneyVN, XlsxColumn } from "@/core/helpers/exportXlsx";
import Permission from "@/core/config/Permission";
import { hideModal } from "@/core/helpers/dom";
import { debounce } from "debounce";
import CKEditor from '@ckeditor/ckeditor5-vue';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import { formatCurrent } from "./freesubject.vue";
import { reFormatCurrent } from "./scholarship.vue";

interface IPagination {
    currentPage: number;
    total: number;
    limit: number;
}
interface TypeData {
    id: string;
    isactive: boolean;
    promotionName: string;
    priority: string;
    promotionCode: string;
    appliedType: [];
    appliedObject: Array<{ type: string, value: Array<string>}>;
    startedDate: string;
    endedDate: string;
    benefit: Array<{ name: string, type: string, value: string, allowMultiPromotions: boolean }> | [];
    benefitaddition: Array<{ name: string, type: string, value: string, allowMultiPromotions: boolean }> | [];
    description: string;
    maxvalue: string;
    isregistrationfeerequest: boolean;
    programtype: string;
    bypasscondition?: boolean;
    adminonly?: boolean;
}

export const typeOptionsSemester = ref<Array<{code: string, name: string}>>([ 
    { code: "1", name: "1 Học kỳ" }, 
    { code: "2", name: "2 Học kỳ" }, 
    { code: "3", name: "3 Học kỳ" }, 
    { code: "4", name: "4 Học kỳ" }, 
    { code: "5", name: "5 Học kỳ" },
    { code: "6", name: "6 Học kỳ" }, 
    { code: "7", name: "7 Học kỳ" }, 
    { code: "8", name: "8 Học kỳ" }, 
    { code: "9", name: "9 Học kỳ" }, 
    { code: "10", name: "10 Học kỳ" },
    { code: "11", name: "11 Học kỳ" },
])
export default defineComponent({
    name: "customers-listing",
    components: {
        Datatable,
        ckeditor: CKEditor.component
    },
    data() {
        return {
            filter: {} as any,
            loading: false,
            editorConfig: {}
        }
    },
    watch: {
        search: debounce(async function (this) {
            this.searchItems()
        }, 300),
        //Lưu xong (submit nằm trong setup, không gọi được method của Options) -> tăng reloadTick
        //để nạp lại bảng TỪ SERVER. Trước đây chỉ vá 1 dòng bằng tay nên hàng vừa lưu thiếu field
        //(điều kiện, các cờ) và initCustomers — nguồn của ô tìm kiếm — vẫn giữ dữ liệu cũ.
        reloadTick(this: any) {
            this.getData()
        },
    },
    methods: {
        //Số thứ tự section: section "Ưu đãi cộng thêm" chỉ hiện khi CHƯA bật Multibuy, nên không được
        //đánh số cứng (bật Multibuy là dãy số nhảy 1,2,4). Tính theo đúng các section đang hiển thị.
        sectionNo(key) {
            //Thứ tự theo nghiệp vụ: định danh -> GIẢM BAO NHIÊU -> khi nào được hưởng -> cho ai -> chữ hiển thị
            const visible = ['info', 'detail', 'condition']
            if (this.formData?.benefitaddition && this.formData.benefitaddition.length == 0) {
                visible.push('addition')
            }
            visible.push('scope', 'desc')
            return visible.indexOf(key) + 1
        },
        //Cảnh báo MỀM: rà các ô để trống / cấu hình bất thường dễ gây sai tiền.
        //Chỉ ĐỌC formData để hiển thị, KHÔNG chặn Lưu (có ưu đãi cố tình để trống chờ nhập sau).
        formWarnings() {
            const f = this.formData || {}
            const out = [] as any[]
            const isMultibuy = !!f.ismultibuy
            const benefit = Array.isArray(f.benefit) ? f.benefit : []
            const addition = Array.isArray(f.benefitaddition) ? f.benefitaddition : []

            //Hết hạn mà vẫn bật -> vẫn trừ tiền (BE không chặn)
            const ended = Array.isArray(f.dateGroup) ? f.dateGroup[1] : null
            const started = Array.isArray(f.dateGroup) ? f.dateGroup[0] : null
            //"Bỏ qua điều kiện" vô hiệu hoá luôn khoảng hiệu lực -> các cảnh báo về ngày không còn đúng,
            //đổi thành cảnh báo ngược lại: ngày ghi trong form không còn tác dụng.
            if (f.bypasscondition) {
                if (f.isactive && (ended || started)) {
                    out.push('Đang bật "Bỏ qua điều kiện" — "Thời gian áp dụng" và "Điều kiện kích hoạt" KHÔNG còn hiệu lực, '
                        + 'ưu đãi hiện ra để chọn chừng nào còn bật Kích hoạt. Muốn dừng thì tắt Kích hoạt.')
                }
            }
            else {
                if (f.isactive && ended && this.isExpired(ended)) {
                    out.push('Đã quá "Thời gian áp dụng" nhưng vẫn bật Kích hoạt — hồ sơ MỚI không chọn được nữa (đã lọc theo hạn), '
                        + 'nhưng hồ sơ đã chọn trước đó vẫn giữ nguyên khoản giảm cũ khi thu tiền. Nên tắt Kích hoạt cho gọn danh sách.')
                }
                if (f.isactive && started && new Date(started).setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0)) {
                    out.push('Chưa tới ngày bắt đầu — ưu đãi sẽ tự hiện cho sinh viên kể từ ngày bắt đầu, không cần tắt Kích hoạt.')
                }
            }
            if (f.adminonly) {
                out.push('Đang bật "Chỉ admin chọn" — cổng sinh viên KHÔNG hiện ưu đãi này để chọn; sinh viên chỉ thấy (dạng chỉ xem) sau khi tư vấn viên đã cấp trong hồ sơ nhập học.')
            }
            if (!(f.appliedType || []).length) {
                out.push('Chưa chọn "Áp dụng cho" — ưu đãi sẽ không khớp gói học phí nào.')
            }
            //Bản ghi cũ lỡ có CẢ hai kiểu giảm -> 2 đường ống đều trừ. Lưu lại sẽ tự dọn theo Multibuy.
            if (benefit.length && addition.length === 0 && isMultibuy) {
                out.push('Bản ghi này đang có cả khoản giảm cố định lẫn mức Multibuy — bấm Lưu để hệ thống giữ lại đúng phần Multibuy (nếu không sẽ bị trừ tiền 2 lần).')
            }
            //Không có khoản giảm nào -> giảm 0đ
            if (!isMultibuy && !benefit.length) {
                out.push('Mục "Chi tiết ưu đãi" chưa có khoản giảm nào — ưu đãi sẽ không trừ tiền.')
            }
            if (!isMultibuy && benefit.some(b => !b.type || b.value === '' || b.value === null || b.value === undefined)) {
                out.push('Có khoản giảm chưa chọn Loại hoặc chưa nhập Giá trị.')
            }
            if (isMultibuy && addition.some(b => !b.semester || !b.type || b.value === '' || b.value === null || b.value === undefined)) {
                out.push('Có mức Multibuy chưa nhập đủ (Đóng từ / Kiểu giảm / Mức giảm).')
            }
            //Giảm theo % mà không đặt trần -> số tiền giảm không giới hạn
            const hasPercent = (isMultibuy ? addition : benefit).some(b => b.type == 'percent')
            if (hasPercent && !f.maxvalue) {
                out.push('Đang giảm theo % nhưng chưa đặt "Giá trị tối đa" — mức giảm sẽ không có trần.')
            }
            if (f.isCondition && f.condition && (!f.condition.date || !f.condition.type || !f.condition.description)) {
                out.push('Bật "Điều kiện kích hoạt" nhưng chưa nhập đủ Thời gian / Loại / Mô tả.')
            }
            return out
        },
        //Chọn nhanh 11 học kỳ (tương đương bấm tay từng option, không đụng logic lưu)
        selectAllAppliedType() {
            this.formData.appliedType = typeOptionsSemester.value.map(i => i.code)
        },
        clearAppliedType() {
            this.formData.appliedType = []
        },
        //--- Helper hiển thị cho bảng danh sách (thuần format, không đụng dữ liệu) ---
        formatDateVN(value) {
            if (!value) { return '—' }
            const d = new Date(value)
            return isNaN(d.getTime()) ? '—' : d.toLocaleDateString('vi-VN')
        },
        //Quá ngày kết thúc: BE/FE KHÔNG tự chặn ưu đãi hết hạn -> phải nhìn thấy ở danh sách
        isExpired(endedDate) {
            if (!endedDate) { return false }
            const d = new Date(endedDate)
            return !isNaN(d.getTime()) && d.getTime() < new Date().setHours(0, 0, 0, 0)
        },
        //appliedType lưu mảng/CSV mã học kỳ -> đổi sang nhãn "n Học kỳ"
        appliedTypeList(appliedType) {
            if (!appliedType) { return [] }
            const codes = Array.isArray(appliedType) ? appliedType : String(appliedType).split(',')
            return codes
                .map(c => String(c).trim())
                .filter(c => c !== '')
                .map(c => typeOptionsSemester.value.find(i => i.code == c)?.name || c)
        },
        funcChangeMultiBuy(checked) {
            // console.log('checked',checked)
            if(checked) {
                this.addArrItemAddition()
                this.formData.benefit = []
                this.arrPromotion = [
                    {
                        name: "",
                        value: "",
                        description: "",
                        condition: [],
                    }
                ]
            }
            else {
                this.formData.benefitaddition = []
            }
        },
        formatCurrentMoney(e) {
            return formatCurrent(e)
        },
        isNumber(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        addCondition (index) {
            let temp = {
                date: "",
                value: "",
                description: "",
            }
            this.arrPromotion[index].condition.push(temp)
        },
        removeRowCondition(index,ind) {
            if(this.arrPromotion[index].condition.length >0) {
                this.arrPromotion[index].condition = this.arrPromotion[index].condition.filter((i,ic) =>ic != ind)
            }
        },
        removeRowScholar(index) {
            if(this.arrPromotion.length >1) {
                this.arrPromotion = this.arrPromotion.filter((i,ind) =>ind != index)
            }
        },
        addNewRow() {
            let temp = {
                name: "",
                value: "",
                description: "",
                condition: [],
            }
            this.arrPromotion.push(temp)
        },
        onReady( editor )  {
        //Insert the toolbar before the editable area.
        setTimeout(() => {
          console.log('editor.ui.view.toolba',editor.ui.view.toolbar)
          editor.ui.getEditableElement().parentElement.insertBefore(
            editor.ui.view.toolbar.element,
            // editor.ui.view.toolbar.element,
            
            editor.ui.getEditableElement()
          );
        }, 100);
        this.editorModel = editor
    },
        changeOption(e) {
            this.checkActiveSchool = []
            this.checkActiveSchool = [e.pop()]

        },
        changeOptionSpecial(e) {
            // FIX: bỏ tick hết -> e=[] -> e.pop()=undefined -> [undefined] lưu DB thành [null] (dirty). Chỉ giữ lựa chọn cuối, rỗng thì để [].
            const last = e[e.length - 1]
            this.formData.condition.specialApplied = last ? [last] : []
        },
        exportFile() {
            // Xuất Excel phía FE có style — dùng helper chung exportStyledXlsx (không qua /utilities/exportexcel)
            const columns: XlsxColumn[] = [
                { label: "Chương trình ưu đãi", width: 32, wrap: true },
                { label: "Mã ưu đãi", width: 20 },
                { label: "Kích hoạt", width: 10, align: "C" },
                { label: "Loại chương trình", width: 16, align: "C" },
                { label: "Độ ưu tiên", width: 10, align: "C" },
                { label: "Tên ưu đãi", width: 36, wrap: true },
                { label: "Loại ưu đãi", width: 14, align: "C" },
                { label: "Giá trị ưu đãi", width: 16, align: "R" },
                { label: "Giá trị tối đa", width: 14, align: "R" },
                { label: "Cộng dồn ưu đãi", width: 14, align: "C" },
                { label: "ĐK: Số kỳ đóng học phí", width: 24, wrap: true },
                { label: "ĐK: Đóng phí ghi danh", width: 18, align: "C" },
                { label: "Đối tượng áp dụng", width: 30, wrap: true },
                { label: "Ngành áp dụng", width: 30, wrap: true },
                { label: "Ngày bắt đầu", width: 12, align: "C" },
                { label: "Ngày kết thúc", width: 12, align: "C" },
                { label: "Mô tả", width: 50, wrap: true },
            ]
            // Nhãn loại ưu đãi tiếng Việt (không lấy từ promotionTypeOptions vì mảng này bị lọc động)
            const benefitTypeLabels: Record<string, string> = { gift: 'Quà tặng', percent: 'Phần trăm (%)', amount: 'Số tiền (VNĐ)' }
            const formatBenefitValue = (type: string, value: any) => {
                if (value === null || value === undefined || value === '') return ''
                if (type === 'percent') return `${value}%`
                if (type === 'amount') return `${formatMoneyVN(value)} đ`
                return String(value) // gift
            }
            const formatSemesters = (val: any) => {
                const arr = Array.isArray(val) ? val : (val ? [val] : [])
                if (!arr.length) return ''
                if (arr.length >= 11) return 'Mọi số kỳ (1–11)'
                return `Đóng ${arr.join(', ')} học kỳ`
            }
            try {
                const rows: any[][] = []
                const rowGroups: number[] = [] // index chương trình của từng dòng -> tô nền xen kẽ theo NHÓM
                this.tableData.forEach((item: any, groupIdx: number) => {
                    const appliedObject = item.appliedObject.reduce((tol: any[], pre) => [...tol, ...pre.value], []).map(v => {
                        const schoolname = this.schoolOptions1.find(f => f.id == v)?.name
                        if (schoolname) return `${v}_${schoolname}`
                    }).filter(Boolean)
                    const appliedObjectText = appliedObject.length ? appliedObject.join(', ') : 'Tất cả'

                    // Ngành áp dụng: đổi mã -> tên cho đầy đủ, rỗng = tất cả ngành
                    const appliedMajorNames = (Array.isArray(item.appliedmajor) ? item.appliedmajor : [])
                        .map(code => this.majorOptions.find(m => m.value == code)?.label || code)
                    const appliedMajorText = appliedMajorNames.length ? appliedMajorNames.join(', ') : 'Tất cả ngành'

                    // Cột chung của chương trình (lặp lại trên mỗi dòng ưu đãi)
                    const baseCols = {
                        name: item.promotionName || '',
                        code: item.promotionCode || '',
                        active: item.isactive === false ? 'Không' : 'Có',
                        program: this.optionsPrograms.find((v) => v.value == item.programtype)?.label || item.programtype || '',
                        priority: item.priority ?? '',
                        maxvalue: formatMoneyVN(item.maxvalue),
                        regfee: item.isregistrationfeerequest ? 'Có' : 'Không',
                        object: appliedObjectText,
                        major: appliedMajorText,
                        started: item.startedDate ? new Date(item.startedDate).toLocaleDateString("en-GB") : '',
                        ended: item.endedDate ? new Date(item.endedDate).toLocaleDateString("en-GB") : '',
                        description: item.description || '',
                    }
                    const pushRow = (b: { name: string; type: string; value: string; multi: string; semesters: string }) => {
                        rows.push([
                            baseCols.name, baseCols.code, baseCols.active, baseCols.program, baseCols.priority,
                            b.name, b.type, b.value, baseCols.maxvalue, b.multi,
                            b.semesters, baseCols.regfee, baseCols.object, baseCols.major,
                            baseCols.started, baseCols.ended, baseCols.description,
                        ])
                        rowGroups.push(groupIdx)
                    }

                    // 1) Ưu đãi thường (benefit[])
                    const benefits = Array.isArray(item.benefit) ? item.benefit : []
                    benefits.forEach(benefit => {
                        pushRow({
                            name: benefit.name || '',
                            type: benefitTypeLabels[benefit.type] || benefit.type || '',
                            value: formatBenefitValue(benefit.type, benefit.value),
                            multi: benefit.allowMultiPromotions ? 'Có' : 'Không',
                            semesters: formatSemesters(item.appliedType),
                        })
                    })
                    // 2) Ưu đãi phân bậc theo số học kỳ (benefitaddition[]) — CT con GV/NV, đối tác... lưu ở đây
                    const benefitAdditions = Array.isArray(item.benefitaddition) ? item.benefitaddition : []
                    benefitAdditions.forEach(benefit => {
                        pushRow({
                            name: benefit.name || '',
                            type: benefitTypeLabels[benefit.type] || benefit.type || '',
                            value: formatBenefitValue(benefit.type, benefit.value),
                            multi: '',
                            semesters: benefit.semester ? `Đóng ${benefit.semester} học kỳ` : '',
                        })
                    })
                    // 3) CT chưa cấu hình ưu đãi nào -> vẫn xuất 1 dòng để không sót chương trình
                    if (!benefits.length && !benefitAdditions.length) {
                        pushRow({ name: '(Chưa cấu hình ưu đãi)', type: '', value: '', multi: '', semesters: formatSemesters(item.appliedType) })
                    }
                })

                exportStyledXlsx({
                    title: 'DANH SÁCH CHƯƠNG TRÌNH ƯU ĐÃI',
                    summary: `Tổng: ${this.tableData.length} chương trình (${rows.length} dòng ưu đãi)`,
                    sheetName: 'Chương trình ưu đãi',
                    fileBaseName: 'chuong-trinh-uu-dai',
                    columns,
                    rows,
                    rowGroups,
                })
            } catch (error) {
                console.log('err', error)
                Swal.fire({
                    text: 'Không thể xuất file Excel.',
                    icon: 'error',
                    buttonsStyling: false,
                    confirmButtonText: 'Đóng',
                    customClass: { confirmButton: 'btn btn-primary' },
                })
            }
        },
        checkItemActiveArr() {
            this.promotionTypeOptions = [{ code: 'gift', name: 'Gift' }, { code: 'percent', name: 'Percent' }, { code: 'amount', name: 'Amount' }]
            this.formData.benefit.forEach(e => {
                this.promotionTypeOptions = this.promotionTypeOptions.filter(a => a.code != e.type)
            })
        },
        addArrItem() {
            if (this.formData.benefit.length == 3) return;
            if (this.formData.benefit.length > 0) {
                const item = this.formData.benefit[this.formData.benefit.length - 1]
                if (!item.name || !item.type || !item.value) return;
            }
            let temp = {
                name:"", 
                type: "", 
                value: "", 
                allowMultiPromotions: false
            }
            this.formData.benefit.push(temp)
        },
        delArrItem(type){
            const lookArr = this.formData.benefit.filter(e=>e.type != type)
            this.formData.benefit = lookArr
            this.checkItemActiveArr()
        },
        addArrItemAddition() {
            // console.log('this.formData',this.formData)
            if (this.formData.benefitaddition.length > 0) {
                const item = this.formData.benefitaddition[this.formData.benefitaddition.length - 1]
                if (!item.semester || !item.type || !item.value) return;
            }
            let temp = {
                name: "",
                semester:"", 
                type: "", 
                value: "", 
            }
            this.formData.benefitaddition.push(temp)
        },
        delArrItemAddition(ind){
            const lookArr = this.formData.benefitaddition.filter((e,index)=>index != ind)
            this.formData.benefitaddition = lookArr
        },
        
        callModalAddApp(e) {
            e.preventDefault()
            this.isEdit = false
            this.kt_modal_add_combination?.click()
            this.resetDataForm()
        },
        resetDataForm() {
            if (!this.formRef) return
            this.formRef.resetFields()
            this.checkActiveSchool = []
            this.checkCity = null
            this.checkDistric = null
            this.checkSchool = null
            // this.formData.benefit = []
            let temp = {
                isactive: false,
                promotionName: "",
                priority: "",
                promotionCode: "",
                appliedType: [],
                appliedObject: [
                    { type: "SCHOOLID", value: []},
                    { type: "MAJORID", value: []},
                    { type: "STUDENTID", value: []},
                ],
                startedDate: "",
                endedDate: "",
                benefit: [],
                benefitaddition: [],
                description: "",
                dateGroup: [],
                maxvalue: "",
                isregistrationfeerequest: false,
                programtype: "", 
                condition: {
                    value: "",
                    date: "",
                    description: "",
                    code: "",
                    specialApplied: [],
                },
                addition: [],
                ismultibuy: false,
                ismanual: false,
                bypasscondition: false,
                adminonly: false,
            } as any
            this.formData = temp
            this.arrPromotion = [
                {
                    name: "",
                    value: "",
                    description: "",
                    condition: [],
                }
            ]
            this.checkItemActiveArr()
        },
        deleteRow(record) {
            Swal.fire({
                text: `Bạn có muốn xóa ngân hàng này không?`,
                icon: "question",
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: "Đồng ý",
                cancelButtonText: "Trở lại",
                customClass: {
                    confirmButton: "btn btn-primary order-2",
                    cancelButton: "btn btn-light order-1",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    let index = this.tableData.findIndex(item => item.id == record.id)
                    this.tableData.splice(index, 1);
                    axios.delete(`/setting/promotion/${record.id}`)
                }
                Swal.close()
            });
        },
        async setDataForm(record) {
            if (!this.formRef) return
            this.formRef.resetFields()
            this.checkActiveSchool = []
            this.idFormEdit = record.id
            await axios.get(`/setting/promotion/${record.id}`)
                .then(({ data }) => {
                    data.appliedObject = this.formatAppliedObject(data)
                    data.description = data.description?data.description:''
                    data.appliedType = data.appliedType.split(",");
                    data.benefitaddition = data.benefitaddition||[]
                    if(data.benefitaddition && data.benefitaddition.length != 0) {
                        data.ismultibuy = true
                    }
                    if(data.condition) {
                        data.isCondition = true
                        data.condition.value = data.condition.value.toLocaleString('vi-VN')
                        data.condition.specialApplied = data.condition.specialApplied||[]
                        delete data.isExclSchoolarship

                    }
                    else {
                        data.condition = {
                            value: "",
                            date: "",
                            description: "",
                            type: "",
                            specialApplied: [],
                        }
                    }
                    if(data.addition) {
                        data.addition.forEach((item: any) => {
                            item.value = item.value.toLocaleString('vi-VN')
                            item.condition?.forEach((i: any) => {
                                i.value = i.value.toLocaleString('vi-VN')
                            })
                        })
                        this.arrPromotion = data.addition
                        data.isAddition = true
                        
                    }
                    else {
                        this.arrPromotion = [
                            {
                                name: "",
                                value: "",
                                description: "",
                                condition: [],
                            }
                        ]
                    }
                    this.formData = data as any
                    this.formData.dateGroup = [new Date(data.startedDate), new Date(data.endedDate)]
                    const findSchool = data.appliedObject.find(e=>e.type=="SCHOOLID")
                    const findMajor = data.appliedObject.find(e=>e.type=="MAJORID")
                    const findStudent = data.appliedObject.find(e=>e.type=="STUDENTID")
                    
                    
                    this.checkActiveSchool = []
                    if(findSchool && findSchool.value.length != 0){
                        this.checkActiveSchool.push(0)
                    }
                    else if (findMajor && findMajor.value.length != 0){
                        this.checkActiveSchool.push(1)
                    }
                    else if (findStudent && findStudent.value.length != 0){
                        this.checkActiveSchool.push(2)
                    }
                    
                    this.checkItemActiveArr()
                    this.isEdit = true
                    this.kt_modal_add_combination?.click()
                })
                .catch(({ response }) => {
                    console.log('err', response)
                });
        },
        formatAppliedObject(item: any) {
            console.log('itemitem',item)
            let appliedObject = [
                {
                    type: 'SCHOOLID',
                    value: []
                },
                {
                    type: 'MAJORID',
                    value: []
                },
                {
                    type: 'STUDENTID',
                    value: []
                },
                
            ]
            appliedObject.forEach((i:any)=> {
                let data = item.appliedObject.find((it:any) => it.type == i.type)
                // console.log('data',data)
                if(data) {
                    i.value = data?.value
                }
            })
            console.log('appliedObject',appliedObject)

            return appliedObject
        },
        async getData() {
            this.loading = true
            this.tableData = []
            this.initCustomers = []
            await axios.get(`/setting/promotion`)
                .then(({ data }) => {
                    //this.pagination.total = data.itemCount
                    //this.pagination.currentPage = page
                    data.forEach((item, idx) => {
                        
                        let temp = {
                            id: item.id,
                            isactive: item.isactive,
                            promotionName: item.promotionName,
                            priority: item.priority,
                            promotionCode: item.promotionCode,
                            appliedType: item.appliedType,
                            appliedObject: this.formatAppliedObject(item),
                            startedDate: item.startedDate,
                            endedDate: item.endedDate,
                            benefit: item.benefit||[],
                            benefitaddition: item.benefitaddition||[],
                            condition: item.condition, // chỉ để hiện chip "Điều kiện" ở cột Chi tiết
                            description: item.description,
                            maxvalue: item.maxvalue,
                            isregistrationfeerequest: item.isregistrationfeerequest,
                            programtype: item.programtype,
                            ismanual: item.ismanual, // badge cột Phạm vi
                            bypasscondition: item.bypasscondition, // badge "Bỏ qua ĐK" + gạch ngang cột Thời gian
                            adminonly: item.adminonly, // badge "Chỉ admin"
                        } as any
                        this.tableData.push(temp)
                    })
                    // Sắp xếp mặc định: ĐANG KÍCH HOẠT lên trước (ưu đãi đang chạy mới là thứ cần nhìn),
                    // trong mỗi nhóm thì theo TÊN ƯU ĐÃI A→Z (so sánh kiểu tiếng Việt).
                    this.tableData.sort((a, b) => {
                        const act = (x) => (x.isactive === false ? 1 : 0)
                        if (act(a) !== act(b)) { return act(a) - act(b) }
                        return (a.promotionName || '').localeCompare(b.promotionName || '', 'vi')
                    })
                    this.initCustomers.splice(0, this.tableData.length, ...this.tableData);
                    //Giữ ô tìm kiếm + bộ lọc sau khi nạp lại (vd vừa Lưu xong), đừng bật lại full danh sách
                    if (this.search || this.filterActive || this.filterPriority) { this.searchItems() }
                    this.loading = false
                })
                .catch(({ response }) => {
                    console.log('err', response)
                });
        },
        currentChange(currentPage, limit = 0) {
            if (limit == 0) {
                limit = this.pagination.limit
            }
            else {
                this.pagination.limit = limit
            }
            //this.getData()
        },
        async changeSelectCity(event){
            this.checkCity = event
            this.checkDistric = ""
            this.checkSchool = ""
            this.districOptions = []
            this.schoolOptions = []
            await axios.get(`/district?pvcode=${event}`)
                .then(({ data }) => {
                    data.forEach(item => {
                        let temp = {
                            code: item.code,
                            name: item.name,
                        }
                        this.districOptions.push(temp)
                    })
                })
                .catch(({ response }) => {
                    console.log('err', response)
                });
        },
        async changeSelectDistric(event){
            this.checkDistric = event
            this.checkSchool = ""
            this.schoolOptions = []
            await axios.get(`/school?pvcode=${this.checkCity}&dtcode=${event}`)
                .then(({ data }) => {
                    data.forEach(item => {
                        let temp = {
                            id: item.id,
                            name: item.name,
                        }
                        this.schoolOptions.push(temp)
                        console.log(item)
                    })
                })
                .catch(({ response }) => {
                    console.log('err', response)
                });
        },
        changeSelectSchool(event){
            this.checkSchool = event
            if(!this.formData.appliedObject[0]?.value.find(e=>e == event)){
                this.formData.appliedObject[0]?.value.push(event)
            }
        }
    },
    async created() {
        await axios.get('/major')
            .then(({ data }) => {
                data.forEach(item => {
                    let temp = {
                        majorName: item.name,
                        majorCode: item.code,
                        shortname: item.shortname,
                    }
                    this.optionsMajor.push(temp)
                })
            })
            .catch(({ response }) => {
                console.log('err', response)
            });
        axios.get(`/province`)
            .then(({ data }) => {
                data.forEach(item => {
                    let temp = {
                        code: item.code,
                        name: item.name,
                    }
                    this.cityOptions.push(temp)
                })
            })
            .catch(({ response }) => {
                console.log('err', response)
            });
            axios.get(`/school`)
                .then(({ data }) => {
                    data.forEach(item => {
                        let temp = {
                            id: item.id,
                            name: item.name,
                        }
                        this.schoolOptions1.push(temp)
                    })
                })
                .catch(({ response }) => {
                    console.log('err', response)
                });
                axios.get(`/major`)
                .then(({ data }) => {
                    data.forEach(item => {
                        let temp = {
                            ...item,
                            value: item.code,
                            label: item.name,
                        }
                        this.majorOptions.push(temp)
                    })
                })
                .catch(({ response }) => {
                    console.log('err', response)
                });
                axios.get(`/admission/passed/official`)
                .then(({ data }) => {
                    this.studentOptions = []
                    data.items.forEach(item => {
                        let temp = {
                            value: item.idStudent,
                            label: item.profileCode +'-'+item.fullName
                        }
                        this.studentOptions.push(temp)
                    })
                })
                .catch(({ response }) => {
                    console.log('err', response)
                });
                
        await this.getData()
    },
    setup() {
        const editor = DecoupledEditor
        const editorModel = ref({} as any)
        const optionsMajor = ref([] as any)
        
        const rulesDefault = ref({
            required: true,
            message: "Vui lòng điền trường này",
            trigger: ['blur','change'],
        })
        const optionsType = ref([
        {
            label: "Tuition Fee",
            value: 'Tuition Fee'
        },
        {
            label: "Deposit",
            value: 'Deposit'
        },
        ])
        const checkActiveSchool = ref<any>([])
        const promotionTypeOptions = ref<any>([{ code: 'gift', name: 'Gift'},{ code: 'percent', name: 'Percent'},{ code: 'amount', name: 'Amount'} ])
     
        const checkCity = ref()
        const checkDistric= ref()
        const checkSchool= ref()
        
        
        const arrPromotion = ref<any>([
            {
                name: "",
                value: "",
                description: "",
                condition: [],
            }
        ])
        const optionsPrograms = ref([
            {
                label: "Song Ngữ",
                value: "SONG_NGU",
            },
            {
                label: "Tiếng Việt",
                value: "TIENG_VIET",
            },
        ])
        const cityOptions = ref<Array<{code: string, name: string}>>([])
        const districOptions = ref<Array<{code: string, name: string}>>([])
        const schoolOptions = ref<Array<{id: string, name: string}>>([])
        const schoolOptions1 = ref<Array<{id: string, name: string}>>([])
        const majorOptions = ref<any>([])
        const studentOptions = ref<any>([])
            
        const addCombinationModalRef = ref<null | HTMLElement>(null);
        const kt_modal_add_combination = ref<null | HTMLElement>(null);
        const initCustomers = ref<Array<TypeData>>([]);
        //Đếm số lần cần nạp lại bảng — Options `watch.reloadTick` gọi getData() (xem watch ở trên)
        const reloadTick = ref(0);
        const isEdit = ref(false);
        const idFormEdit = ref('');
        const pagination = ref<IPagination>({ currentPage: 1, total: 0, limit: 25, });
        const filterList = ref<any>();
        const formData = ref<any>(
            { isactive: false ,promotionName: "", priority: "", promotionCode: "", appliedType: [], 
            appliedObject: [ 
                    { type: "SCHOOLID", value: []},
                    { type: "MAJORID", value: []},
                    { type: "STUDENTID", value: []},
                ],
                 dateGroup: [], startedDate: "", endedDate: "", benefit: [], description: "",maxvalue: "",isregistrationfeerequest: false,
                programtype: "",
                condition: {
                    value: "",
                    date: "",
                    description: "",
                    code: "",
                    specialApplied: [],
                },
                addition: [],  
                benefitaddition: [],
            })
        const tableData = ref<Array<TypeData>>([]);
        const search = ref<string>("");
        //Bộ lọc bảng: '' = tất cả; filterActive 'y' đang kích hoạt / 'n' đang tắt
        const filterActive = ref<string>("");
        const filterPriority = ref<string>("");
        const tableHeader = ref([
            {
                name: "Ưu đãi",
                key: "promotionName",
                sortable: false,
                class: "text-nowrap",
            },
            {
                name: "Ưu tiên",
                key: "priority",
                sortable: true,
                class: "text-center min-w-70px text-nowrap"
            },
            {
                name: "Áp dụng cho",
                key: "appliedType",
                sortable: false,
                class: "text-nowrap",
            },
            {
                name: "Thời gian áp dụng",
                key: "startedDate",
                sortable: false,
                class: "min-w-160px text-nowrap"
            },
            {
                name: "Chi tiết",
                key: "benefits",
                sortable: false,
                class: "text-nowrap",
            },
            {
                name: "Phạm vi",
                key: "scope",
                sortable: false,
                class: "text-nowrap",
            },
            {
                name: "Mô tả",
                key: "description",
                sortable: false,
                class: "text-nowrap",
            },
            {
                // sortable:false — isactive là boolean, sortByAlphabet sẽ throw trên giá trị không phải chuỗi
                // Đặt CUỐI bảng (2026-07-23): đây là cờ trạng thái, không phải thông tin đọc theo hàng ngang
                name: "K.H",
                key: "isactive",
                sortable: false,
                class: "text-center min-w-70px text-nowrap"
            },
            {
                name: "",
                key: "actions",
                sortable: false,
                class: "text-center min-w-50px text-nowrap"
            },
        ]);
        const formRef = ref<HTMLFormElement | null>(null);
        const rules = ref({
            promotionName: [
                {
                required: true,
                message: "Vui lòng điền trường này",
                trigger: "change",
                },
            ],
            promotionCode: [
                {
                required: true,
                message: "Vui lòng điền trường này",
                trigger: "change",
                },
            ],
            priority: [
                {
                required: true,
                message: "Vui lòng điền trường này",
                trigger: "change",
                },
            ],
            appliedType: [
                {
                required: true,
                message: "Vui lòng điền trường này",
                trigger: "change",
                },
            ],
            dateGroup: [
                {
                required: true,
                message: "Vui lòng điền trường này",
                trigger: "change",
                },
            ],
            // maxvalue: [
            //     {
            //     required: true,
            //     message: "Vui lòng điền trường này",
            //     trigger: "change",
            //     },
            // ],
            
            description: [
                {
                required: true,
                message: "Vui lòng điền trường này",
                trigger: "change",
                },
            ],
        })
        const submit = async (formEl: HTMLFormElement | null) => {
            if (!formEl) return;
            await formEl.validate(async (valid, fields) => {
                if (valid) {
                    // console.log('checkActiveSchool.value',checkActiveSchool.value)
                    formData.value.appliedObject.forEach((item: any, index: number) => {
                        if(index != checkActiveSchool.value[0]) {
                            item.value = []
                        }
                        else if(index > 2 && checkActiveSchool.value[0] > 2) {
                            item.value = checkActiveSchool.value
                        }
                    }) 
                    let condition = null as any
                    let addition = null as any
                    if(formData.value.isCondition) {
                        condition = formData.value.condition
                        condition.value = reFormatCurrent(condition.value)
                    }
                    if(formData.value.isAddition) {
                        addition = JSON.parse(JSON.stringify(arrPromotion.value))
                        addition.forEach((item: any) => {
                            item.value = reFormatCurrent(item.value)
                            item.condition?.forEach((i: any) => {
                                i.value = reFormatCurrent(i.value)
                            })
                        })
                        
                    }
                    let method = isEdit.value ? 'put' : 'post'
                    let id = isEdit.value ? `/${idFormEdit.value}` : ''
                    let data: any = {
                        isactive: formData.value.isactive,
                        promotionName: formData.value.promotionName != "" ? formData.value.promotionName : undefined,
                        priority: formData.value.priority ? formData.value.priority : undefined,
                        promotionCode: formData.value.promotionCode != "" ? formData.value.promotionCode : undefined,
                        appliedType: formData.value.appliedType ? formData.value.appliedType.toString() : undefined,
                        appliedObject: formData.value.appliedObject,
                        startedDate: formData.value.dateGroup != "" ? formData.value.dateGroup[0] : undefined,
                        endedDate: formData.value.dateGroup != "" ? moment(formData.value.dateGroup[1]).local().endOf('day').toISOString() : undefined,
                        //MỘT kiểu giảm cho mỗi chương trình: Multibuy -> chỉ benefitaddition, ngược lại -> chỉ benefit.
                        //Có cả hai thì 2 đường ống tính tiền (ưu đãi chính / theo số HK) đều trừ -> mất tiền 2 lần.
                        //BE cũng chặn (_assertBenefitExclusive); chốt luôn ở đây để bản ghi cũ lỡ dính cả hai
                        //vẫn lưu lại được sạch thay vì bị 400.
                        benefit: formData.value.ismultibuy ? [] : (formData.value.benefit.length != 0 ? formData.value.benefit : []),
                        benefitaddition: formData.value.ismultibuy ? (formData.value.benefitaddition.length != 0 ? formData.value.benefitaddition : []) : [],
                        
                        description: formData.value.description != "" ? formData.value.description : undefined,
                        maxvalue: (formData.value.maxvalue && formData.value.maxvalue != "") ? +reFormatCurrent(formData.value.maxvalue) : null,
                        isregistrationfeerequest: formData.value.isregistrationfeerequest,
                        programtype: formData.value.programtype ? formData.value.programtype : null,
                        "addition": addition,
                        "condition": condition,
                        "appliedmajor": formData.value.appliedmajor ? formData.value.appliedmajor : undefined,
                        "ismanual": formData.value.ismanual,
                        "bypasscondition": !!formData.value.bypasscondition,
                        "adminonly": !!formData.value.adminonly,

                    }
                    await axios[method](`/setting/promotion${id}`, data)
                        .then(() => {
                            //Nạp lại bảng từ server (watch reloadTick -> getData) thay vì vá 1 dòng:
                            //bản vá cũ thiếu condition/appliedObject đã format + không đụng initCustomers.
                            reloadTick.value++
                            hideModal(addCombinationModalRef.value);
                        })
                        .catch(({ response }) => {
                            console.log('err', response)
                        });
                } else {
                    console.log('error submit!', fields)
                }
            })
        };
        //Ô tìm kiếm + 2 bộ lọc (Kích hoạt / Ưu tiên) dùng CHUNG một hàm: luôn dựng lại từ initCustomers
        //rồi lọc chồng, nếu không thì lọc cái này sẽ xoá kết quả của cái kia.
        const searchItems = () => {
            let rows = [...initCustomers.value] as any[]
            if (search.value !== "") {
                rows = rows.filter(r => searchingFunc(r, search.value))
            }
            if (filterActive.value) {
                rows = rows.filter(r => (r.isactive === false ? 'n' : 'y') === filterActive.value)
            }
            if (filterPriority.value) {
                rows = rows.filter(r => String(r.priority ?? '') === filterPriority.value)
            }
            tableData.value.splice(0, tableData.value.length, ...rows);
        };
        //Các mức ưu tiên ĐANG CÓ trong dữ liệu (khỏi liệt kê cứng 1..10 rồi lọc ra rỗng)
        const priorityOptions = () => {
            const set = new Set(initCustomers.value
                .map((i: any) => i.priority)
                .filter(p => p !== '' && p !== null && p !== undefined && !isNaN(+p))
                .map(p => +p))
            return Array.from(set).sort((a: any, b: any) => a - b)
        };
        const searchingFunc = (obj, value): boolean => {
            obj = JSON.parse(JSON.stringify(obj))
            for (let key in obj) {
                if (obj[key] && (typeof obj[key] === "string")) {
                    if (obj[key].toUpperCase().indexOf(value.toUpperCase()) != -1) {
                        return true;
                    }
                }
            }
            return false;
        };
        return {
            editor,
            editorModel,
            checkActiveSchool,
            rules,
            formRef,
            tableData,
            initCustomers,
            reloadTick,
            tableHeader,
            search,
            filterActive,
            filterPriority,
            priorityOptions,
            pagination,
            searchItems,
            filterList,
            Permission,
            submit,
            promotionTypeOptions,
            schoolOptions,
            schoolOptions1,
            cityOptions,
            districOptions,
            checkCity,
            checkDistric,
            checkSchool,
            formData,
            isEdit,
            idFormEdit,
            kt_modal_add_combination,
            addCombinationModalRef,
            optionsPrograms,
            majorOptions,
            studentOptions,
            rulesDefault,
            arrPromotion,
            optionsType,
            optionsMajor,
            typeOptionsSemester,
        };
    },
});
